import "./kendo.data.aspnetmvc.js";

(function($, undefined) {
    var kendo = window.kendo,
        ui = kendo.ui;

    if (ui && ui.TabStrip) {
        ui.TabStrip._enableDOMDataSource = true;
    }

})(window.kendo.jQuery);
